<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
          <b-col lg="3">
            <b-input-group size="sm" class="mt-1">
              <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
              <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                  ></b-form-input>
              <b-input-group-append>
              <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
              </b-input-group-append>
              </b-input-group>
          </b-col> 
          <b-col lg="9">
            <b-form-group
              label="FILTER ON :"
              label-cols-sm="2"
              description="Leave all unchecked to filter on all data"
              class="mb-0">
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="nomor">nomor</b-form-checkbox>
                <b-form-checkbox value="uraian">Budget Name</b-form-checkbox>
                <b-form-checkbox value="jccostname">Item Name</b-form-checkbox>
                <b-form-checkbox value="jccostnote">Item Note </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>                
          </b-col>                 
      </b-row>
        <b-table
          class="mb-0"
          ref="tblBudget" style="font-size:smaller;" 
          responsive striped hover
          :items="tblData.items"
          :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"

          @row-clicked="selectItem"           
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"                
        >
        <!-- <template v-slot:cell(noprodintern)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:100px !important;">
          {{ data.item.noprodintern }}</div>
        </template> -->
        <template v-slot:cell(uraian)="data">
                    {{data.item.uraian}}
                    No.Prod: {{ data.item.noprodintern }}
        </template>

        <template v-slot:cell(quantity)="data">
            {{data.item.quantity}} {{data.item.unitsize}}
            <span v-if="(data.item.repetit_qty)"> ({{data.item.repetit_qty}} | {{data.item.repetit_nm}})</span>                            
        </template>
        <template v-slot:cell(ibbudgetamt)="data">
          {{data.item.ibbudgetamt | numFormat}}
        </template>
        <!-- <template v-slot:cell(requestamt)="data">
          {{data.item.requestamt | numFormat}}
        </template> -->
        </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{(tblData.page - 1) * tblData.limit + 1}}
          to
          <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span>
          <span v-else>{{tblData.page * tblData.limit}}</span>
          of {{tblData.total}} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <input type="number" style="width:80px;" v-model="tblData.limit"/>
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>

      </div>
</template>

<script>
import budgetinternal from "../../apis/budgetinternal";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomorintern",
            label: "Budget#",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Budget Name",
            sortable: true,
          },
          {
            key: "jccostname",
            label: "Item Name",
            sortable: true
          },
          {
              key: "jccostnote",
              label: "item Note",
              thClass: "text-center",
          },
          {
            key: "quantity",
            label: "QTY",
            thStyle: "width:40px",
          },
          {
            key: "ibbudgetamt",
            label: "IB Amount",
            thStyle: "width:100px",
            tdClass: "text-right",
            sortable: true,
          },

      ],
      tblData: {
        items:[],
        total: 0,
        page: 1,
        limit:15,
        sortBy: 'seqNo',
        status: "111",
        sortDesc: true
      },
      filter:null,
      filterOn: [],
      updatetable:false,
      lkuLoading:false,
    };
  },
  // watch: {
  //   "tblData.page": function(newval) {
  //     // this.tblData.page=newval;
  //     this.refresh();
  //   },   
  //   "tblData.limit": function(newval) {
  //     this.refresh();
  //   },   
  // },
  props: ["ibudghdkey","formdata"],
  created: async function() {
      this.tblData.ibudghdkey=this.ibudghdkey || '';
      if (this.ibudghdkey) {
        if (this.formdata.items)
        {
          if (this.formdata.items[0].ibudghdkey!==this.ibudghdkey) {
            this.data();
          } else {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
          }
        } else {
          this.data();
        }
      } else {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        }
      }
  },

  methods: {
     onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.filterOn= []   
      this.filter= '';   
    },
    data: async function(ctx) {
      // this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true; 
      if (this.tblData.ibudghdkey) {
        const list = await budgetinternal.line({page: 1,limit:1000,sortBy: 'seqNo',sortDesc: true, ibudghdkey: this.tblData.ibudghdkey});     
        this.tblData.items=list;
        this.tblData.total=list.length;
      }

          // console.log('IB Lines : ',this.tblData);
      this.lkuLoading=false;      
      this.updatetable=!this.updatetable;

      // return list;
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblBudget.refresh();
       }
    },    
    refresh() {
      this.data();
    this.$refs.tblBudget.refresh();
    }
  }
};
</script>
